// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class BallThrowData implements flatbuffers.IUnpackableObject<BallThrowDataT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BallThrowData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBallThrowData(bb:flatbuffers.ByteBuffer, obj?:BallThrowData):BallThrowData {
  return (obj || new BallThrowData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBallThrowData(bb:flatbuffers.ByteBuffer, obj?:BallThrowData):BallThrowData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BallThrowData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

speed():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endSpeed():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

startX():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

startY():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

startZ():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endX():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endY():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endZ():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedX():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedY():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

projectedZ():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX1():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX2():number {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialX3():number {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY1():number {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY2():number {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialY3():number {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ1():number {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ2():number {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

polynomialZ3():number {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

startTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

endTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

landingTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

static startBallThrowData(builder:flatbuffers.Builder) {
  builder.startObject(23);
}

static addSpeed(builder:flatbuffers.Builder, speed:number) {
  builder.addFieldFloat32(0, speed, 0.0);
}

static addEndSpeed(builder:flatbuffers.Builder, endSpeed:number) {
  builder.addFieldFloat32(1, endSpeed, 0.0);
}

static addStartX(builder:flatbuffers.Builder, startX:number) {
  builder.addFieldFloat32(2, startX, 0.0);
}

static addStartY(builder:flatbuffers.Builder, startY:number) {
  builder.addFieldFloat32(3, startY, 0.0);
}

static addStartZ(builder:flatbuffers.Builder, startZ:number) {
  builder.addFieldFloat32(4, startZ, 0.0);
}

static addEndX(builder:flatbuffers.Builder, endX:number) {
  builder.addFieldFloat32(5, endX, 0.0);
}

static addEndY(builder:flatbuffers.Builder, endY:number) {
  builder.addFieldFloat32(6, endY, 0.0);
}

static addEndZ(builder:flatbuffers.Builder, endZ:number) {
  builder.addFieldFloat32(7, endZ, 0.0);
}

static addProjectedX(builder:flatbuffers.Builder, projectedX:number) {
  builder.addFieldFloat32(8, projectedX, 0.0);
}

static addProjectedY(builder:flatbuffers.Builder, projectedY:number) {
  builder.addFieldFloat32(9, projectedY, 0.0);
}

static addProjectedZ(builder:flatbuffers.Builder, projectedZ:number) {
  builder.addFieldFloat32(10, projectedZ, 0.0);
}

static addPolynomialX1(builder:flatbuffers.Builder, polynomialX1:number) {
  builder.addFieldFloat32(11, polynomialX1, 0.0);
}

static addPolynomialX2(builder:flatbuffers.Builder, polynomialX2:number) {
  builder.addFieldFloat32(12, polynomialX2, 0.0);
}

static addPolynomialX3(builder:flatbuffers.Builder, polynomialX3:number) {
  builder.addFieldFloat32(13, polynomialX3, 0.0);
}

static addPolynomialY1(builder:flatbuffers.Builder, polynomialY1:number) {
  builder.addFieldFloat32(14, polynomialY1, 0.0);
}

static addPolynomialY2(builder:flatbuffers.Builder, polynomialY2:number) {
  builder.addFieldFloat32(15, polynomialY2, 0.0);
}

static addPolynomialY3(builder:flatbuffers.Builder, polynomialY3:number) {
  builder.addFieldFloat32(16, polynomialY3, 0.0);
}

static addPolynomialZ1(builder:flatbuffers.Builder, polynomialZ1:number) {
  builder.addFieldFloat32(17, polynomialZ1, 0.0);
}

static addPolynomialZ2(builder:flatbuffers.Builder, polynomialZ2:number) {
  builder.addFieldFloat32(18, polynomialZ2, 0.0);
}

static addPolynomialZ3(builder:flatbuffers.Builder, polynomialZ3:number) {
  builder.addFieldFloat32(19, polynomialZ3, 0.0);
}

static addStartTime(builder:flatbuffers.Builder, startTime:number) {
  builder.addFieldFloat32(20, startTime, 0.0);
}

static addEndTime(builder:flatbuffers.Builder, endTime:number) {
  builder.addFieldFloat32(21, endTime, 0.0);
}

static addLandingTime(builder:flatbuffers.Builder, landingTime:number) {
  builder.addFieldFloat32(22, landingTime, 0.0);
}

static endBallThrowData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createBallThrowData(builder:flatbuffers.Builder, speed:number, endSpeed:number, startX:number, startY:number, startZ:number, endX:number, endY:number, endZ:number, projectedX:number, projectedY:number, projectedZ:number, polynomialX1:number, polynomialX2:number, polynomialX3:number, polynomialY1:number, polynomialY2:number, polynomialY3:number, polynomialZ1:number, polynomialZ2:number, polynomialZ3:number, startTime:number, endTime:number, landingTime:number):flatbuffers.Offset {
  BallThrowData.startBallThrowData(builder);
  BallThrowData.addSpeed(builder, speed);
  BallThrowData.addEndSpeed(builder, endSpeed);
  BallThrowData.addStartX(builder, startX);
  BallThrowData.addStartY(builder, startY);
  BallThrowData.addStartZ(builder, startZ);
  BallThrowData.addEndX(builder, endX);
  BallThrowData.addEndY(builder, endY);
  BallThrowData.addEndZ(builder, endZ);
  BallThrowData.addProjectedX(builder, projectedX);
  BallThrowData.addProjectedY(builder, projectedY);
  BallThrowData.addProjectedZ(builder, projectedZ);
  BallThrowData.addPolynomialX1(builder, polynomialX1);
  BallThrowData.addPolynomialX2(builder, polynomialX2);
  BallThrowData.addPolynomialX3(builder, polynomialX3);
  BallThrowData.addPolynomialY1(builder, polynomialY1);
  BallThrowData.addPolynomialY2(builder, polynomialY2);
  BallThrowData.addPolynomialY3(builder, polynomialY3);
  BallThrowData.addPolynomialZ1(builder, polynomialZ1);
  BallThrowData.addPolynomialZ2(builder, polynomialZ2);
  BallThrowData.addPolynomialZ3(builder, polynomialZ3);
  BallThrowData.addStartTime(builder, startTime);
  BallThrowData.addEndTime(builder, endTime);
  BallThrowData.addLandingTime(builder, landingTime);
  return BallThrowData.endBallThrowData(builder);
}

unpack(): BallThrowDataT {
  return new BallThrowDataT(
    this.speed(),
    this.endSpeed(),
    this.startX(),
    this.startY(),
    this.startZ(),
    this.endX(),
    this.endY(),
    this.endZ(),
    this.projectedX(),
    this.projectedY(),
    this.projectedZ(),
    this.polynomialX1(),
    this.polynomialX2(),
    this.polynomialX3(),
    this.polynomialY1(),
    this.polynomialY2(),
    this.polynomialY3(),
    this.polynomialZ1(),
    this.polynomialZ2(),
    this.polynomialZ3(),
    this.startTime(),
    this.endTime(),
    this.landingTime()
  );
}


unpackTo(_o: BallThrowDataT): void {
  _o.speed = this.speed();
  _o.endSpeed = this.endSpeed();
  _o.startX = this.startX();
  _o.startY = this.startY();
  _o.startZ = this.startZ();
  _o.endX = this.endX();
  _o.endY = this.endY();
  _o.endZ = this.endZ();
  _o.projectedX = this.projectedX();
  _o.projectedY = this.projectedY();
  _o.projectedZ = this.projectedZ();
  _o.polynomialX1 = this.polynomialX1();
  _o.polynomialX2 = this.polynomialX2();
  _o.polynomialX3 = this.polynomialX3();
  _o.polynomialY1 = this.polynomialY1();
  _o.polynomialY2 = this.polynomialY2();
  _o.polynomialY3 = this.polynomialY3();
  _o.polynomialZ1 = this.polynomialZ1();
  _o.polynomialZ2 = this.polynomialZ2();
  _o.polynomialZ3 = this.polynomialZ3();
  _o.startTime = this.startTime();
  _o.endTime = this.endTime();
  _o.landingTime = this.landingTime();
}
}

export class BallThrowDataT implements flatbuffers.IGeneratedObject {
constructor(
  public speed: number = 0.0,
  public endSpeed: number = 0.0,
  public startX: number = 0.0,
  public startY: number = 0.0,
  public startZ: number = 0.0,
  public endX: number = 0.0,
  public endY: number = 0.0,
  public endZ: number = 0.0,
  public projectedX: number = 0.0,
  public projectedY: number = 0.0,
  public projectedZ: number = 0.0,
  public polynomialX1: number = 0.0,
  public polynomialX2: number = 0.0,
  public polynomialX3: number = 0.0,
  public polynomialY1: number = 0.0,
  public polynomialY2: number = 0.0,
  public polynomialY3: number = 0.0,
  public polynomialZ1: number = 0.0,
  public polynomialZ2: number = 0.0,
  public polynomialZ3: number = 0.0,
  public startTime: number = 0.0,
  public endTime: number = 0.0,
  public landingTime: number = 0.0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return BallThrowData.createBallThrowData(builder,
    this.speed,
    this.endSpeed,
    this.startX,
    this.startY,
    this.startZ,
    this.endX,
    this.endY,
    this.endZ,
    this.projectedX,
    this.projectedY,
    this.projectedZ,
    this.polynomialX1,
    this.polynomialX2,
    this.polynomialX3,
    this.polynomialY1,
    this.polynomialY2,
    this.polynomialY3,
    this.polynomialZ1,
    this.polynomialZ2,
    this.polynomialZ3,
    this.startTime,
    this.endTime,
    this.landingTime
  );
}
}
